import React from 'react';
import Theme from '+/instances/Theme';
import { PreferencesForm } from './PreferencesForm';

export const Preferences = () => (
  <Theme light>
    <PreferencesForm />
  </Theme>
);
